import React from 'react';
import { Link } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaPencilAlt, FaTrash, FaPlus, FaFileExport, FaEnvelope } from 'react-icons/fa';
import SalesOrderDetails from './SalesOrderDetails';
import SaleInstallmentList from './SaleInstallmentList';
import InstallmentPopUp from './InstallmentPopUp';
import SalesOrderAPI from '../../api/SalesOrderAPI';
import RoomAPI from '../../api/RoomAPI';
import PropertyAPI from '../../api/PropertyAPI';
import ApiUiController from '../../controller/ApiUiController';
import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import Display from '../../util/Display';
import Util from '../../util/Util';
import Papa from 'papaparse';
import moment from 'moment';
import Dropdown from 'react-bootstrap/Dropdown';
import EmailPopup from '../email/EmailPopupNew';

class SalesOrderPreview extends React.Component {

  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.products = reactLocalStorage.getObject(Const.Products);
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.sales_order;
    this.users = this.models.user.options;
    this.source = this.models.source.options;
    this.currency = this.models.currency.options;
    this.units = this.models.unit_measure.options;
    this.project = this.models.project.options;
    this.property_type = this.models.sales_order.fields.property_type.options;
    this.sales_type = this.models.sales_order.fields.sales_type.options;
    this.state = { inApiCall: true, popup: false, popupData: null, designView: reactLocalStorage.get("booking_design") || "2" };
    this.probability = this.models.probability.options;
    this.sale = {};
    this.update = '';
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Export = Util.isAllow(this.model.permission, Const.PermExport);
    this.InstallView = Util.isAllow(this.models.sales_order.permission, Const.PermView);
    this.InstallAdd = Util.isAllow(this.models.sales_order.permission, Const.PermAdd);
    this.InstallUpdate = Util.isAllow(this.models.sales_order.permission, Const.PermUpdate);
    this.EmailAdd = Util.isAllow(this.models.email.permission, Const.PermAdd);
  }

  componentDidMount() {
    SalesOrderAPI.get(this.id, this.onReceived, this.onFail);
  }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    this.sale = res;
    this.update = `/sales-order/add-edit/${this.sale.model_no}/${this.sale.model_id}/${this.sale.id}`;
    if (this.sale.project && this.sale.tower && this.sale.room) {
      RoomAPI.getRoom(this.sale.room, this.onRoomReceived, this.onFail);
    } else if (this.sale.property) {
      PropertyAPI.get(this.sale.property, this.onPropertyReceived, this.onFail);
    } else {
      this.setState({ ...this.state, inApiCall: false });
    }
  };

  onRoomReceived = res => {
    if (res.room) {
      this.model.fields.room['options'] = [{ label: res.room.room_name, value: res.room.id }];
    }
    if (res.tower) {
      this.model.fields.tower['options'] = [{ label: res.tower.tower_name, value: res.tower.id }];
    }
    if (res.property) {
      this.model.fields.property['options'] = [{ label: res.property.name, value: res.property.id }];
    }
    this.setState({ ...this.state, inApiCall: false });
  };

  onPropertyReceived = property => {
    this.model.fields.property['options'] = [{ label: property.name, value: property.id }];
    this.setState({ ...this.state, inApiCall: false });
  };

  refresh = () => {
    this.setState({ ...this.state, popup: false, inApiCall: true });
    SalesOrderAPI.get(this.id, this.onReceived, this.onFail);
  };

   setDesign = (designView) => {
    reactLocalStorage.set("booking_design", designView);
    this.setState({ designView }, () => {
      window.location.reload();
    });
  };


  showPopUp = (data, field) => this.setState({ ...this.state, popupData: data, popup: field });
  hidePopUp = () => this.setState({ ...this.state, popup: null });

  onPreview = () => {
    if (this.sale.model_no === Const.Lead) {
      this.props.navigate(`/lead/preview/${this.sale.model_id}`);
    } else if (this.sale.model_no === Const.Contact) {
      this.props.navigate(`/contact/preview/${this.sale.model_id}`);
    }
  };

  delete = () => {
    Util.confirmAlert('Delete', 'Are you sure you want to delete', 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      SalesOrderAPI.delete(this.sale.id, this.onDelete, this.onFail);
    });
  };

  onDelete = () => {
    Util.showNotification('Successful', 'Sales Order Deleted successfully', 'success');
    this.props.navigate('/sales-order');
  };

  onExport = () => {
    const data = { ...this.sale };
    Object.keys(data).forEach(key => {
      if (typeof data[key] === 'string' && data[key].indexOf(Const.Opt) !== -1) {
        data[key] = data[key].split(Const.Opt).join('');
      }
      if (data[key] === null || data[key] === '~~' || data[key] === '') {
        data[key] = '-';
      }
    });

    data.source = this.source.find((pro) => pro.value === data?.source)?.label;
    data.probability = this.probability.find((pro) => pro.value === data?.probability)?.label;
    data.currency = this.currency.find((pro) => pro.value === data?.currency)?.label;
    data.responsible_person = this.users.find((pro) => pro.value === data.responsible_person)?.name;
    data.sales_person = this.users.find((pro) => pro.value === data.sales_person)?.name;
    data.project = this.project.find((pro) => pro.value === data.project)?.label;
    data.property = this.project.find((pro) => pro.value === data.property)?.label;
    data.property_type = this.project.find((pro) => pro.value === data.property_type)?.label;
    data.sales_type = this.project.find((pro) => pro.value === data.sales_type)?.label;
    data.start_date = moment(data.start_date).format('YYYY-MM-DD');
    data.end_date = moment(data.end_date).format('YYYY-MM-DD');
    data.created_date = moment(data.created_date).local().format('DD-MM-YYYY HH:mm:ss');
    data.updated_date = moment(data.updated_date).local().format('DD-MM-YYYY HH:mm:ss');
    data.created_by = this.users.find((pro) => pro.value === data.created_by)?.name;
    data.updated_by = this.users.find((pro) => pro.value === data.updated_by)?.name;

    this.generateCSV(data);

  };

  generateCSV = (data) => {
    try {
      const csv = Papa.unparse([data], { header: true });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'SalesOrder.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      Util.showNotification('Successful', 'Sales Order Data Downloaded successfully', 'success');
    } catch (error) {
      console.error("Error generating CSV:", error);
      Util.showError("Failed to generate CSV file");
    } finally {
      this.setState({ inApiCall: false });
    }
  };

  render() {
    let isCompleted = this.sale && this.sale.probability === 1;
        const { designView } = this.state;

    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        {(this.InstallAdd || this.InstallUpdate) ?
          <InstallmentPopUp show={this.state.popup === Const.Installment} hide={this.hidePopUp} sale={this.sale}
            installment={this.state.popupData} reload={this.refresh} />
          : null
        }
        { this.EmailAdd ? 
          <EmailPopup
            show={this.state.popup === Const.Email}
            onHide={this.hidePopUp}
            data={{
              ...this.sale,
              ...( this.state.popupData ? { installment_id: this.state.popupData?.id } : {} )
            }}
            model={null}
            reload={this.refresh}
            model_no={null}
            model_id={null}
          /> : null
        }
        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="topRow">
              <div className="row pb-2">
                <div className="col-md-4">
                  <p>
                    <span className="salesTopHeading">
                      {Display.FieldValue(this.sale, 'model', this.model.fields)}
                    </span>
                  </p>
                </div>
                <div className="col-md-8">
                  <Dropdown className="d-inline-block mr-2">
                    <Dropdown.Toggle variant="outline-dark" size="sm" id="design-dropdown">
                      Design {designView}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => this.setDesign('1')}>Design 1</Dropdown.Item>
                      <Dropdown.Item onClick={() => this.setDesign('2')}>Design 2</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  {this.Export &&
                    <Link className="buttons history" onClick={this.onExport}><FaFileExport /> Export</Link>
                  }
                  <span className="buttons add" onClick={this.onPreview}>View Lead Details</span>
                  {this.EmailAdd &&
                    <span className="buttons add" onClick={() => this.showPopUp(null, Const.Email)}>
                      <FaEnvelope /> Email
                    </span>
                  }
                  {this.Update &&
                    <Link to={this.update} className="buttons update"><FaPencilAlt /> Update</Link>
                  }
                  {this.Delete &&
                    <span className="buttons delete" onClick={this.delete}>
                      <FaTrash /> Delete
                    </span>
                  }
                  {isCompleted && this.InstallAdd &&
                    <span className="buttons add" onClick={() => this.showPopUp(null, Const.Installment)}>
                      <FaPlus /> Installment
                    </span>
                  }
                </div>
              </div>
            </div>

            <div className="row detailsDiv">
              <SalesOrderDetails i={0} sale={this.sale} model={this.model} isCompleted={isCompleted} />
              <SalesOrderDetails i={1} sale={this.sale} model={this.model} isCompleted={isCompleted} />
              <SalesOrderDetails i={2} sale={this.sale} model={this.model} isCompleted={isCompleted} />
            </div>

            {isCompleted && this.InstallView &&
              <SaleInstallmentList sale={this.sale} edit={this.showPopUp} reload={this.refresh} />
            }
          </div>
        </div>
      </ApiUiController>
    );
  }
}
export default withRouter(SalesOrderPreview);